var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasData)?_c('div',{staticClass:"acceso-agua"},[_c('div',{staticClass:"asu-title"},[_vm._v("Internación reciente")]),_c('CaracteristicasFisicasEstadistica',{attrs:{"data":_vm.chartData,"options":{ pieHole: 0 }}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }